import { defaultFieldResolver } from 'graphql';
import { SchemaDirectiveVisitor } from '@graphql-tools/utils';
export function attachDirectiveResolvers(schema, directiveResolvers) {
    if (typeof directiveResolvers !== 'object') {
        throw new Error(`Expected directiveResolvers to be of type object, got ${typeof directiveResolvers}`);
    }
    if (Array.isArray(directiveResolvers)) {
        throw new Error('Expected directiveResolvers to be of type object, got Array');
    }
    const schemaDirectives = Object.create(null);
    Object.keys(directiveResolvers).forEach(directiveName => {
        schemaDirectives[directiveName] = class extends SchemaDirectiveVisitor {
            visitFieldDefinition(field) {
                const resolver = directiveResolvers[directiveName];
                const originalResolver = field.resolve != null ? field.resolve : defaultFieldResolver;
                const directiveArgs = this.args;
                field.resolve = (...args) => {
                    const [source /* original args */, , context, info] = args;
                    return resolver(() => new Promise((resolve, reject) => {
                        const result = originalResolver.apply(field, args);
                        if (result instanceof Error) {
                            reject(result);
                        }
                        resolve(result);
                    }), source, directiveArgs, context, info);
                };
            }
        };
    });
    SchemaDirectiveVisitor.visitSchemaDirectives(schema, schemaDirectives);
}
//# sourceMappingURL=attachDirectiveResolvers.js.map